import CustomTable from "./custom_table";
import ReceiptIcon from "@mui/icons-material/Receipt";
import TableChartIcon from "@mui/icons-material/TableChart";

export const inf_partner = [
    {
        label: "Nombre Completo",
        accessor: "fullusername",
        sm: 14,
        dfl: "",
        type: "text",
        data_select: [],
        name_select: "",
        section: "User",
        sectionTitle: "Usuario",
        change: true,
        required: true,
        maxLength: 100,
        minLength: 0,
        visible: true,
        method: "ALL",
        icon: ReceiptIcon,
    },

    {
        label: "Nombre de Usuario",
        accessor: "username",
        sm: 8,
        dfl: "",
        type: "text",
        data_select: [],
        name_select: "",
        section: "User",
        sectionTitle: "Usuario",
        change: true,
        required: true,
        maxLength: 100,
        minLength: 0,
        visible: true,
        method: "ALL",
        icon: ReceiptIcon,
    },

    {
        label: "Número Telefonico",
        accessor: "phone",
        sm: 8,
        dfl: "",
        type: "number",
        data_select: [],
        name_select: "",
        section: "User",
        sectionTitle: "Usuario",
        change: true,
        required: true,
        maxLength: 100,
        minLength: 0,
        visible: true,
        method: "ALL",
        icon: ReceiptIcon,
    },

    {
        label: "Correo Electronico",
        accessor: "email",
        sm: 15,
        dfl: "",
        type: "text",
        data_select: [],
        name_select: "",
        section: "User",
        sectionTitle: "Usuario",
        change: true,
        required: true,
        maxLength: 100,
        minLength: 0,
        visible: true,
        method: "ALL",
        icon: ReceiptIcon,
    },

    {
        label: "Puesto",
        accessor: "job",
        sm: 15,
        dfl: "",
        type: "text",
        data_select: [],
        name_select: "",
        section: "User",
        sectionTitle: "Usuario",
        change: true,
        required: true,
        maxLength: 100,
        minLength: 0,
        visible: true,
        method: "ALL",
        icon: ReceiptIcon,
    },

    {
        label: "Table",
        accessor: "rol",
        sm: 30,
        dfl: "",
        type: "custom",
        data_select: [],
        name_select: "",
        section: "custom",
        sectionTitle: "Roles",
        change: true,
        required: false,
        maxLength: 1000,
        minLength: 0,
        visible: true,
        customComponent: CustomTable,
        method: "ALL",
        icon: TableChartIcon,
    }
];
